import BalanceHour from "app/models/balanceHour"
import { Action, Types } from "./balanceHours.actions"

export type BalanceHoursState = {
  errors: {}
  data: BalanceHour[]
  estimatedData: BalanceHour[]
  loading: boolean
}

const initialState: BalanceHoursState = {
  data: [],
  estimatedData: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): BalanceHoursState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.GET_ESTIMATED:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_ESTIMATED_SUCCESS:
      return {
        ...state,
        estimatedData: action.payload.estimatedData,
        loading: false,
      }

    case Types.GET_ESTIMATED_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
